import {getCookie} from '../../utils/cookies'
import {firstAppLockedAnchorDealImpressionsTimestampConfig} from './cookieConfig'

/**
 * Gets the first app locked anchor deal impressions timestamp from cookies.
 * @returns The first impressions timestamp string or undefined
 */
export const getFirstAppLockedAnchorDealImpressionsTimestamp = () =>
  getCookie(firstAppLockedAnchorDealImpressionsTimestampConfig.name)
